module.exports = __webpack_public_path__ + "static/img/OK.37145e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/OK.png
// module id = nbmo
// module chunks = 1